var map = {
	"./akar/logo.png": 505,
	"./akpa/logo.png": 5006,
	"./aksa/logo.png": 6924,
	"./aksazeytin/logo.png": 255,
	"./alba/logo.png": 239,
	"./albacc/logo.png": 9656,
	"./alsan/logo.png": 427,
	"./asil/logo.png": 5471,
	"./bakour/logo.png": 3651,
	"./borek/logo.png": 4539,
	"./dalyan/logo.png": 8240,
	"./demfood/logo.png": 2738,
	"./demka/logo.png": 6870,
	"./demo/logo.png": 5099,
	"./dutcheys/logo.png": 402,
	"./ecc/logo.png": 9277,
	"./ekomarkt/logo.png": 7047,
	"./elbey/logo.png": 8838,
	"./enka/logo.png": 3346,
	"./erti/logo.png": 3556,
	"./kilic/logo.png": 774,
	"./microfrucht/logo.png": 5522,
	"./pascha/logo.png": 375,
	"./posuda/logo.png": 7507,
	"./redrose/logo.png": 4998,
	"./royal/logo.png": 7994,
	"./sediq/logo.png": 2577,
	"./teka/logo.png": 9688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8727;